import React, { useEffect, useState } from "react";
import { UploadCloud } from "lucide-react";
import { getPendingCount, subscribe } from "../../lib/driverSync";

// Tiny, unobtrusive banner telling the driver that one or more offline
// deliveries are still uploading in the background. Hidden when nothing
// is pending. Updates live as the queue drains.
export function SyncIndicator() {
  const [count, setCount] = useState(getPendingCount());

  useEffect(() => {
    const refresh = () => setCount(getPendingCount());
    const unsub = subscribe(refresh);
    const onOnline = () => refresh();
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOnline);
    const interval = setInterval(refresh, 4000);
    return () => {
      unsub();
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOnline);
      clearInterval(interval);
    };
  }, []);

  if (count <= 0) return null;

  return (
    <div
      className="mb-3 flex items-center gap-2 rounded-md border border-warning/30 bg-warning-bg px-3 py-2 text-xs font-medium text-warning"
      data-testid="driver-sync-indicator"
    >
      <UploadCloud size={14} strokeWidth={1.5} className="flex-shrink-0 animate-pulse" />
      {count === 1
        ? "1 delivery is still uploading — it will finish automatically when you have signal."
        : `${count} deliveries are still uploading — they'll finish automatically when you have signal.`}
    </div>
  );
}
